// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.canvas_wrap[data-v-52422613]{\n    display: flex;\n    justify-content: center;\n}\n#canvas[data-v-52422613]{\n    position: absolute;\n    top: -10px;\n    margin: 0 auto;\n    z-index: 10;\n}\n", ""]);
// Exports
module.exports = exports;
